module.exports = __webpack_public_path__ + "img/yxlnm_common.5c188a2f.png";